import React, { useState, useEffect } from 'react';
import { Modal, Row, Col, Spin, Button, Divider, message, Select, Collapse, Space, Card, Typography } from 'antd';
import axios from 'axios';
import dayjs from 'dayjs';
import ShowDetail from './ShowDetail';
import { FilePdfOutlined, DeleteOutlined, SearchOutlined } from "@ant-design/icons";
import { GET_BATCH, LOADDATA_WORK_CANCEL } from '../../API/apiUrls';

// import { dayFormatOne } from "../file_mid/allFormat";
const { Panel } = Collapse;
const { Title, Text } = Typography;
const { Option } = Select;

const ShowPDF = () => {
    // const { Option } = Select;
    const { confirm } = Modal
    // const [api, contextHolder] = notification.useNotification();
    const token = localStorage.getItem('TOKEN');
    const [loading, setLoading] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allPdf, setAllPdf] = useState([]);
    const [dataPost, setDataPost] = useState({ id: "" });
    const [NO_EMS, setNO_EMS] = useState([]);
    const [NOT_FOUND, setNOT_FOUND] = useState([]);
    const [FOUND, setFOUND] = useState([]);
    const [ALREADY_PROCESSED, setALREADY_PROCESSED] = useState([]);
    const [PROCESS, setPROCESS] = useState([])
    // const [PROCESS, setPROCESS] = useState([
    //     {
    //         batchId: "0200a047-36df-49ae-89ca-c43347d1ed69",
    //         datetime: "2025-06-12T00:00:00+07:00",
    //         dbMatchStatus: "FOUND",
    //         emsNumber: "RB404874963TH",
    //         errorMessage: "",
    //         filePath: "one_images/zenon/LSHzJNtRLgYVXcuFCmNEfn1756194598.pdf",
    //         id: 774,
    //         status: "PROCESS"
    //     }
    // ])
    const [selectedPdfUrl, setSelectedPdfUrl] = useState(null);


    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        setLoading(true);
        await axios
            .get(GET_BATCH)
            // .get("http://localhost:8080/api-ems/get-batch")
            .then(async (res) => {
                console.log("loadData : ", res.data);
                if (res.data) {
                    const summarizedData = res.data
                        .map((day) => {
                            const summary = (day.batchJobs || []).reduce(
                                (acc, job) => {
                                    acc.totalFiles += job.totalFiles;
                                    acc.successCount += job.successCount;
                                    acc.failureCount += job.failureCount;
                                    return acc;
                                },
                                { totalFiles: 0, successCount: 0, failureCount: 0 }
                            );

                            return {
                                date: day.date,
                                ...summary,
                                batchJobs: day.batchJobs || [],
                            };
                        })
                        .sort((a, b) => new Date(b.date) - new Date(a.date)); // 🔹เรียงตามวันที่ (ล่าสุด → เก่า)

                    setAllData(summarizedData);
                } else {
                    setAllData([]);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.log("err", err);
                message.error("เกิดข้อผิดพลาดในการโหลดข้อมูล");
                setLoading(false);
            });
    };


    const dayFormatOne = (value) => {
        if (value) {
            // console.log("vv",value)
            return dayjs(value).format('DD-MM-YYYY');
            // return dayjs(value).format('YYYY-MM-DD');
        } else {
            return ""
        }
    }

    // const handleOk = async () => {
    //     close(false);
    // };

    // const showConfirmEX = (path, label) => {
    //     confirm({
    //         title: 'คุณต้องการที่จะออกใช่หรือไม่...?',
    //         onOk() {
    //             handleCancel()
    //         },
    //         onCancel() {
    //             // message.error('ยกเลิกการลบข้อมูล')
    //         },
    //     });
    // };

    // const handleCancel = () => {
    //     close(false);
    // };

    const onChangeBatch = (data) => {

        // console.log("value", value);
        console.log("data", data);


        setDataPost(data);
    };

    const onLoadData = async (e) => {
        if (dataPost.id === "") {
            message.warning("กรุณาเลือกรอบที่อัปโหลดก่อน");
            return
        }
        setLoading(true);
        // await axios.post("https://api-asset-investigation-1024031113167.asia-southeast1.run.app/api-ems/load-ems-pdf", dataPost)
        await axios.post(LOADDATA_WORK_CANCEL, dataPost)
            // await axios.post("http://localhost:8080/api-ems/load-ems-pdf", { id: dataPost.id })
            .then(async (res) => {
                console.log("loadData ems : ", res.data)
                if (res.data) {
                    // filter ตาม status
                    const noEms = res.data.filter(e => e.dbMatchStatus === "NO_EMS" && e.status === "SUCCESS_READ");
                    const notFound = res.data.filter(e => e.dbMatchStatus === "NOT_FOUND" && e.status === "SUCCESS_READ");
                    const found = res.data.filter(e => e.dbMatchStatus === "FOUND" && e.status === "SUCCESS_READ");
                    const alreadyProcessed = res.data.filter(e => e.dbMatchStatus === "ALREADY_PROCESSED" && e.status === "SUCCESS_READ");
                    const Process = res.data.filter(e => e.status === "PROCESS"); // สถานะกำลังประมวลผล

                    setNO_EMS(noEms);
                    setNOT_FOUND(notFound);
                    setFOUND(found);
                    setALREADY_PROCESSED(alreadyProcessed);
                    setPROCESS(Process)
                } else {
                    setNO_EMS([]);
                    setNOT_FOUND([]);
                    setFOUND([]);
                    setALREADY_PROCESSED([]);
                    setPROCESS([])
                }
                setLoading(false);
            })
            .catch((err) => {
                message.error('เกิดข้อผิดพลาดในการโหลดข้อมูล');
                setLoading(false)
            })
    }

    const showConfirmDelete = (item) => {
        confirm({
            title: 'ลบใบตอบรับ...?',
            content: 'คุณต้องการลบใบตอบรับนี้หรือไม่ ?',
            onOk() {
                handleDelete(item);
            },
        });
    };

    const handleDelete = (item) => {
        message.success('ลบสำเร็จ');

        console.log("delete item", item);

    }

    const renderPanel = (title, items, color) => {
        if (!items || items.length === 0) return null;

        return (
            <Panel
                header={<Text strong style={{ color, fontSize: '16px' }}>{title} ({items.length})</Text>}
                key={title}
                style={{ borderRadius: 10, marginBottom: 16, background: "#fafafa" }}
            >
                {items.map((item, idx) => {
                    const fileUrl = `https://api-upload-image-i67f6gaaqa-as.a.run.app/apimg-pdf/GetImagess/${item.filePath}?token=${token}`;

                    return (
                        <Card
                            key={idx}
                            size="small"
                            style={{
                                marginBottom: 12,
                                borderRadius: 8,
                                border: "1px solid #f0f0f0",
                                background: "#fff",
                            }}
                        >
                            <Row gutter={[12, 12]} align="middle" justify="space-between">
                                {/* ข้อมูล EMS */}
                                <Col xs={24} sm={14} md={16}>
                                    <Text strong>เลข EMS: </Text>
                                    <Text type="primary" style={{ color: 'blue', fontWeight: "bold" }}>{item.emsNumber}</Text>
                                    <br />
                                    <Text strong>วันที่ออกจดหมาย: </Text>
                                    <Text type="primary" style={{ color: 'red', fontWeight: "bold" }}>{item.datetime ? dayjs(item.datetime).format('DD-MM-YYYY') : '-'}</Text>
                                </Col>

                                {/* ปุ่ม */}
                                <Col xs={24} sm={10} md={8}>
                                    <Space wrap size="small">
                                        <Button
                                            type="primary"
                                            icon={<FilePdfOutlined />}
                                            onClick={() => setSelectedPdfUrl(fileUrl)}
                                            style={{ minWidth: 120 }}
                                        >
                                            แสดง PDF
                                        </Button>

                                        <Button
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => showConfirmDelete(item)}
                                            style={{ minWidth: 120 }}
                                        >
                                            ลบ
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>
                        </Card>
                    );
                })}
            </Panel>
        );
    };


    return (
        <div>
            <Spin spinning={loading} size="large" tip="กำลังโหลดข้อมูล...">
                <Row justify="center" style={{ marginTop: 24 }}>
                    <Col span={24}>
                        <Card
                            bordered={false}
                            style={{
                                borderRadius: 16,
                                boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                                padding: 32,
                                background: "#fff",
                            }}
                        >
                            {/* หัวข้อ */}
                            <Row justify="center" style={{ marginBottom: 24 }}>
                                <Col>
                                    <Title level={3} style={{ marginBottom: 0 }}>
                                        รายละเอียด PDF จดหมายตอบรับ
                                    </Title>
                                    {/* <Text type="secondary">ตรวจสอบเอกสารตามวันที่นำเข้า</Text> */}
                                </Col>
                            </Row>

                            {/* เลือกวันที่ */}
                            <Row justify="center" style={{ marginBottom: 24 }}>
                                <Col>
                                    <Space direction="vertical" align="center" size="middle">
                                        <Text strong style={{ fontSize: 16 }}>เลือกวันที่ที่ต้องการ</Text>
                                        <Select
                                            showSearch
                                            style={{
                                                width: 500,  // ไม่เกิน 100% ของ container
                                            }}
                                            size="large"
                                            onChange={(value, option) => onChangeBatch(option.obj)}
                                            placeholder="เลือกวันที่เพื่อค้นหาข้อมูล"
                                            optionFilterProp="children"
                                            filterOption={(inputValue, option) =>
                                                option.children.join("").toLowerCase().includes(inputValue.toLowerCase())
                                            }
                                        >
                                            {allData?.map((e) => (
                                                <Option key={e.date} value={e.date} obj={e}>
                                                    วันที่นำเข้า : {dayFormatOne(e.date)} | ทั้งหมด : {e.totalFiles || 0} ไฟล์ | สำเร็จ : {e.successCount || 0} ไฟล์
                                                </Option>
                                            ))}
                                        </Select>
                                        <Button
                                            type="primary"
                                            size="large"
                                            icon={<SearchOutlined />}
                                            onClick={onLoadData}
                                            style={{ borderRadius: 8, marginTop: 8 }}
                                        >
                                            ค้นหา
                                        </Button>
                                    </Space>
                                </Col>
                            </Row>

                            <Divider />

                            {/* Collapse รายละเอียด */}
                            <Row>
                                <Col span={24}>
                                    {/* <Text strong style={{ fontSize: 16 }}>{`จำนวนเอกสารทั้งหมด ${allData.}`}</Text> */}
                                </Col>
                            </Row>
                            {
                                (NO_EMS.length > 0 || NOT_FOUND.length > 0 || FOUND.length > 0 || ALREADY_PROCESSED.length > 0) ?
                                    <Row justify="center" gutter={[16, 16]}>
                                        <Col span={24}>
                                            <h2 style={{ textAlign: "center", margin: "0 0 16px 0", color: 'green' }}>ประมวลผลสำเร็จ</h2>
                                            <Collapse accordion bordered={false}>
                                                {renderPanel("📦 อ่านเลข EMS ไม่ได้", NO_EMS, "#fa8c16")}
                                                {renderPanel("❌ ไม่เจอเลข EMS ในระบบ", NOT_FOUND, "#ff4d4f")}
                                                {renderPanel("✅ มีเลข EMS ในระบบ", FOUND, "#52c41a")}
                                                {renderPanel("🔁 มีเอกสารซ้ำ", ALREADY_PROCESSED, "#1890ff")}
                                            </Collapse>
                                        </Col>
                                    </Row>

                                    : null
                            }
                            {
                                PROCESS.length > 0 ?
                                    <>
                                        <Row justify="center" gutter={[16, 16]}>
                                            <Col span={24}>
                                                <Divider />
                                            </Col>
                                            <Col span={24}>
                                                <h2 style={{ textAlign: "center", margin: "0 0 16px 0", color: 'blue' }}>กำลังประมวลผล</h2>
                                                <Collapse accordion bordered={false}>
                                                    {renderPanel("🔁 กำลังประมวลผล", PROCESS, "#fa8c16")}
                                                </Collapse>
                                            </Col>
                                        </Row>
                                    </>
                                    : null
                            }

                        </Card>
                    </Col>
                </Row>
            </Spin>

            {/* </Modal > */}
            {
                selectedPdfUrl ?
                    <ShowDetail
                        open={!!selectedPdfUrl}  // เปิด modal เมื่อ selectedPdfUrl != null
                        close={() => setSelectedPdfUrl(null)} // ปิด modal
                        fileUrl={selectedPdfUrl}
                    />
                    : null
            }
            {/* {contextHolder} */}
        </div>
    )
}

export default ShowPDF;
